<mat-form-field>
  <mat-label>{{ title() }}</mat-label>
  <mat-select
    [formControl]="control()"
    [value]="control().value">
    @for (item of list(); track item) {
      <mat-option
      [value]="item"> {{item}}</mat-option>
    }
  </mat-select>
  @if (control().errors) {
    <mat-error>
      {{getError()}}
    </mat-error>
  }
</mat-form-field>
